import type { MiniFeatureProps } from "@/types/home-type";

export default function MiniFeature({
    icon,
    label,
    desc,
    withLine,
}: MiniFeatureProps) {
    const Icon = icon;
    return (
        <>
            <div className="flex flex-col items-center text-center gap-1.5 w-20 sm:w-auto">
                <Icon
                    className="text-[#4A3B2C] dark:text-gold"
                    size={22}
                    strokeWidth={1.5}
                />
                <div className="font-bold text-[#4A3B2C] dark:text-white text-[11px] leading-tight">
                    {label}
                </div>
                <div className="text-gray-600 dark:text-gray-400 text-[10px]">{desc}</div>
            </div>

            {withLine && (
                <div className="w-px h-10 bg-gold-light/30 dark:bg-gray-700 hidden sm:block mt-2"></div>
            )}
        </>
    );
}
